<script>
export default {
  components: {},
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
  computed: {
    getCompanyInfo: function () {
      let cInfo = this.$store.state.appAuth.companyInfo || null
      if (cInfo && cInfo.primary_color) {
        document.body.style.backgroundColor = "rgb(226, 226, 226)"
      }
      return cInfo
    },
  },    
  created: () => {
    document.body.classList.add('authentication-bg')
    document.body.classList.add('authentication-bg-pattern')
  },
}
</script>

<template>
  <div>
    <div class="account-pages mt-3 mb-2">
      <div class="container">
        <slot />
      </div>
    </div>
    <footer class="footer footer-alt">
      <!-- footer, example: © Copyright, 2022, Euro -->
      &copy; {{ $t('copyright') }}, {{ currentYear }},
      {{
        getCompanyInfo && getCompanyInfo.company_name
          ? getCompanyInfo.company_name
          : ''
      }}
      {{
        getCompanyInfo && getCompanyInfo.git_version
          ? ' | ' + getCompanyInfo.git_version
          : ''
      }}
    </footer>
  </div>
</template>
